import { Pagination } from '@mui/material';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as taskRedux from '../redux/TaskRedux';
import TaskTable from './TaskTable';

function NewLeadTable() {
  const dispatch = useDispatch();
  const tasks = useSelector(taskRedux.newLeadTasksSelector);
  const status = useSelector(taskRedux.newLeadTasksStatusSelector);
  const page = useSelector(taskRedux.newLeadTasksPageSelector);
  const count = useSelector(taskRedux.newLeadTasksCountSelector);

  useEffect(() => {
    dispatch(taskRedux.actions.retrieveNewLeadTasks());
  }, []);

  function onPageChange(event, page) {
    dispatch(taskRedux.actions.retrieveNewLeadTasks(page));
  }

  return (
    <div className="card w-100">
      <div className="card-body position-relative" id="kt_not_reachable_body">
        <TaskTable
          tasks={tasks}
          displayOwner={false}
          onRefresh={() => dispatch(taskRedux.actions.retrieveNewLeadTasks())}
          loading={status === 'loading'}
        />
        {count > 0 && (
          <Pagination
            className="mx-auto mt-4 d-flex justify-content-center"
            count={Math.ceil(count / taskRedux.TASKS_PER_PAGE)}
            page={page}
            onChange={onPageChange}
          />
        )}
      </div>
    </div>
  );
}

export default NewLeadTable;
